import { useEffect } from 'react'
import Head from '@components/common/head'
import { getUser } from '@data/api/user'
import UserCntainer from '@pages/user'
import { GetStaticPaths, GetStaticProps } from 'next'
import useSWR from 'swr'
import useAuth from '@/hooks/auth'
import Loading from '@/components/common/loading'
import { trackUserView } from '@/utils/algolia/insights'

interface Props {
  username: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultUser?: any
}

const UserPage = ({ username, defaultUser }: Props) => {
  const { currentUser, isAuthLoading } = useAuth()
  const { data: user, isLoading } = useSWR(
    username ? `/api/user/${username}` : null,
    () => getUser(username),
    { fallbackData: defaultUser },
  )

  useEffect(() => {
    if (isAuthLoading) {
      return
    }
    trackUserView({ userId: currentUser?.id, viewedUserId: user.id })
  }, [ currentUser?.id, isAuthLoading, user ])

  if (isLoading || !user) {
    return (
      <Loading />
    )
  }

  return (
    <>
      <Head
        title={user.name}
        description={user.shortBio}
        url={`/@${user.username}`}
        image={user.user_image}
        user={user.social ? user.social.twitter : ''}
      />
      <UserCntainer user={user} />
    </>
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export const getStaticProps: GetStaticProps = async ({ params: { username = '' }}) => {
  console.log('username', username)
  if (!username) {
    return {
      notFound: true,
      revalidate: 60,
    }
  }

  // fetch user data here
  const user = await getUser(username)

  console.log('user', user)

  // check if user is not exists after fetch
  if (!user || user.error) {
    return {
      notFound: true,
      revalidate: 60,
    }
  }

  return {
    props: {
      username,
      defaultUser: {
        ...user,
        username,
      },
      breadcrumbs: [{ label: user.name }],
    },
    revalidate: 60,
  }
}

export default UserPage
